import React__default from 'react';
import { IsLoadingProvider } from './components/IsLoadingProvider/provider.js';
import { IsOTPSendedProvider } from './components/IsOTPSendedProvider/provider.js';
import { MetaInfoProvider } from './components/MetainfoProvider/provider.js';
import { UserManagerProvider } from './components/UserManagerProvider/provider.js';
import { ValidationContextProvider } from './components/ValidationContextProvider/provider.js';

/** Провайдер для хранения информации о состоянии формы, хранения inst userManager и тд */
const ContextProvider = (props) => {
    const { metaInfo, children, userManager } = props;
    return (React__default.createElement(MetaInfoProvider, { value: metaInfo },
        React__default.createElement(ValidationContextProvider, null,
            React__default.createElement(UserManagerProvider, { value: userManager },
                React__default.createElement(IsOTPSendedProvider, null,
                    React__default.createElement(IsLoadingProvider, null, children))))));
};

export { ContextProvider };
//# sourceMappingURL=providers.js.map
